'use client';

import type { BreadcrumbContent } from '@/core/types';

import { Breadcrumb } from '@/containers/blocks/navigation';

export default function BreadcrumbGenerator({
  content,
  className = '',
}: {
  content: BreadcrumbContent;
  className?: string;
}) {
  return <Breadcrumb items={content.items} className={className} />;
}
